import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatProgressBarModule } from "@angular/material/progress-bar";

import { UserBriefingComponent } from "./containers/user-briefing/user-briefing.component";
import { SharedModule } from "../shared/shared.module";
import { BriefingHistoryComponent } from "./containers/briefing-history/briefing-history.component";
import { BriefingListComponent } from "./components/briefing-list/briefing-list.component";
import { TimelineModule } from "../patient/timeline-view/timeline.module";

@NgModule({
	imports: [CommonModule, SharedModule, TimelineModule, MatProgressBarModule],
	declarations: [UserBriefingComponent, BriefingListComponent, BriefingHistoryComponent],
	exports: [BriefingHistoryComponent, UserBriefingComponent],
})
export class BriefingModule {}
